import React from 'react';
import { getFormattedDate } from '../../../utils/utilities';
import ReactReadMoreReadLess from 'react-read-more-read-less';
import { formatDistance } from 'date-fns';

import './NotificationItem.scss';
import { INotification } from '../HeaderNotification';

const formattedDate = (date: string | number | Date): string | number | boolean => {
    const todayMS = new Date().getTime();
    const dateMS = new Date(date).getTime();
    const dateUTC = new Date(date).toLocaleString();
    const diff = todayMS - dateMS;

    if (diff <= 86400000) {
        return formatDistance(new Date(dateUTC), new Date(), { addSuffix: true });
    } else {
        return getFormattedDate(date, 'PPpp').toString();
    }
};

interface INotificationItemProps extends INotification {
    markAsReed?: (id?: string | number) => Promise<void>
}

export const NotificationItem = (props: INotificationItemProps): JSX.Element => {
    const { markAsReed, date, id, title, read } = props;

    const onClick = async (): Promise<void> => {
        if (!read) {
            markAsReed(id);
        }
    };

    return (
        <li
            key={id}
            className="dropdown-menu-item d-flex justify-content-between mb-5 align-items-center cursor-pointer"
            onClick={onClick}
        >
            {
                !read ? (
                    <div className="cursor-pointer">
                        <div className="icon-circle checked">
                            <div className="icon-center-dot checked"/>
                        </div>
                    </div>
                ) : (
                    <div className="cursor-pointer">
                        <div className="icon-circle ">
                            <div className="icon-center-dot"/>
                        </div>
                    </div>
                )
            }
            <div className="dropdown-menu-item__title col-8 fs-6 cursor-pointer">
                <ReactReadMoreReadLess
                    charLimit={markAsReed ? 50 : 100}
                    readMoreText={'Read more'}
                    readLessText={'Read less'}
                >
                    {title}
                </ReactReadMoreReadLess>
            </div>
            <div className="dropdown-menu-item__time col-2 fs-9 text-center text-muted cursor-pointer">
                {formattedDate(date)}
            </div>
        </li>
    );
};

